import React, { useContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router';
import { IonLoading, IonToast, IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonList, IonItem, IonInput, IonIcon, IonButton, IonCardContent, IonAlert } from '@ionic/react';

// Contexts
import { AppContext } from '../../../contexts';

// Hooks
import { useForm } from '../../../hooks';

// Helpers
import { extractConfigPage } from '../../../helpers';

// Validators
import { FormsValidator } from '../../../validators';

// Actions
import { resetErrorAction, startResetPassword } from '../../../redux';

// Constants
import { APP_CONFIG } from '../../../constants';

// Components
import { ValidatorMessageComponent, HeaderComponent } from '../../../components';

export const ResetPassword = () => {

    const inputs = {

        email: 'email'
    };

    const history = useHistory();
    const dispatch = useDispatch();
    const { error } = useSelector(state => state.app);
    const { email: username } = useSelector(state => state.auth);
    const { isWeb } = useContext(AppContext);
    
    const location = useLocation();
    const pageConfig = extractConfigPage(location);
    const [validation, setValidation] = useState({ summary: null, formValid: false, formComplete: false });
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState({ show: false, error: null });
    const [showAlert, setShowAlert] = useState({ show: false, title: null, message: null });

    const initialForm = {

        email: username
    };

    const [{ email }, handleInputChange, reset] = useForm(initialForm);

    useEffect(() => {

        const validations = FormsValidator.summary([
            () => FormsValidator.required(pageConfig, email, inputs.email),
            () => FormsValidator.maxLength(pageConfig, email, inputs.email),
            () => FormsValidator.minLength(pageConfig, email, inputs.email),
            () => FormsValidator.pattern(pageConfig, email, inputs.email),
        ]);
        
        setValidation({
            summary: validations.filter(v => !v.valid),
            formValid: validations.formValid,
            formComplete: email.length > 0
        });

    }, [email]);

    /**
     * En caso de ocurrir cualquier error al llamar a la API; muestra el mensaje
     */
    useEffect(() => {

        if (error) {

            setShowToast({ show: true, error: error.message });
            dispatch(resetErrorAction());
        }

    }, [error]);

    const handleResetPassword = async (e) => {

        e.preventDefault();

        if (validation.formComplete && validation.formValid) {

            dispatch(startResetPassword(
                email, 
                setLoading, 
                () => setShowAlert({ show: true, message: APP_CONFIG.MESSAGE.ALERT.resetPassword.message, title: APP_CONFIG.MESSAGE.ALERT.resetPassword.title })    
            ));
        }

    };

    return (
        <div className="login-page animate__animated animate__fadeIn slow">

            <IonLoading
                isOpen={loading}
                message={APP_CONFIG.CONTROLS.LOADING.MESSAGE}
            />
            <IonToast
                isOpen={showToast.show}
                onDidDismiss={() => setShowToast(false)}
                message={showToast.error}
                duration={APP_CONFIG.CONTROLS.TOAST.DURATION}
                position={APP_CONFIG.CONTROLS.TOAST.POSITION}
                color="danger"
            />
            {
                <IonAlert
                    isOpen={showAlert.show}
                    onDidDismiss={() => setShowAlert({ show: false, title: null, message: null })}
                    header={showAlert.title}
                    message={showAlert.message}
                    mode="ios"
                    backdropDismiss={false}
                    buttons={[
                        {
                            text: 'OK',
                            handler: () => {

                                history.replace(pageConfig.nextPage);
                            }
                        }
                    ]}
                />
            }

            {
                !isWeb &&
                <HeaderComponent urlRedirect={APP_CONFIG.PAGES.LOGIN.path}/>
            }
            <IonContent className="fondo">

                <IonGrid>
                    <IonRow className="grid-rows-1 state--100vh">
                        <IonCol className="dispFlex-alignCenter-justCenter">
                            <IonCard className={isWeb ? 'web' : 'mobile'}>
                                <IonCardHeader>
                                    <IonCardTitle>
                                        <IonGrid>
                                            <IonRow>
                                                <IonCol className="text-align-center">
                                                <svg width="100" height="100" viewBox="0 0 137 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0.830078 85.5377C0.830078 70.2199 8.60792 59.9733 25.3893 59.9733C30.2836 59.9031 35.1651 60.495 39.9044 61.733V72.7035H34.4957L33.78 66.0805C31.1481 65.5665 28.4766 65.2881 25.7965 65.2484C13.2105 65.2484 8.80946 73.2194 8.80946 84.2938C8.80946 98.7838 13.9261 104.679 25.8993 104.679C28.5462 104.653 31.1848 104.374 33.78 103.847L34.8041 97.2237H40.2293L39.818 107.99C35.0508 109.315 30.1275 109.977 25.1836 109.958C8.60792 109.758 0.830078 101.376 0.830078 85.5377Z" fill="#00043a" />
                                                        <path d="M44.8319 104.605L48.8216 104.293V62.8735H43.9105V58.3181L54.9624 57.5942L55.5752 58.1101V104.605H59.9762V109.139H44.8319V104.605Z" fill="#00043a" />
                                                        <path d="M65.5042 98.8057L65.607 79.3485H61.3089V74.7764L71.7479 74.2605L72.3607 74.7764L72.2579 97.6575C72.0472 99.6915 72.7553 101.713 74.185 103.159C75.6148 104.605 77.6134 105.322 79.6244 105.108C82.6089 104.977 85.49 103.965 87.9123 102.196L88.0151 79.3152H83.6141V74.7764L94.0531 74.2605L94.666 74.7764L94.5631 104.172L98.9641 104.38V108.936L89.2408 109.452L88.7308 108.832L88.2208 105.504C84.9609 108.242 80.894 109.808 76.6589 109.955C73.6465 110.239 70.6641 109.161 68.5121 107.01C66.3601 104.859 65.259 101.856 65.5042 98.8057Z" fill="#00043a" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M104.796 62.8736V108.103C109.201 109.303 113.747 109.887 118.308 109.838C123.34 110.099 128.241 108.161 131.765 104.518C135.288 100.874 137.095 95.8758 136.726 90.7928C136.726 80.6502 131.914 73.8191 121.886 73.8191C118.221 73.859 114.654 75.0192 111.653 77.1473V58.1102L111.04 57.5943L99.9883 58.3182V62.8736H104.796ZM119.739 78.9163C126.271 78.9163 129.561 83.9876 129.561 91.4385V91.4427C129.561 98.5816 126.184 104.897 118.514 104.897C116.158 104.876 113.816 104.527 111.554 103.861V81.296C113.976 79.6714 116.834 78.8405 119.739 78.9163Z" fill="#00043a" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M33.9429 0C23.2472 0 14.5767 8.67054 14.5767 19.3662C14.5767 30.0619 23.2472 38.7324 33.9429 38.7324H106.76C117.455 38.7324 126.126 30.0619 126.126 19.3662C126.126 8.67054 117.455 0 106.76 0H33.9429ZM66.3282 26.7391C67.0377 25.6291 67.4256 24.3531 67.4919 22.9111H62.5392C62.5013 24.0875 62.1796 24.946 61.5742 25.4868C60.9687 26.0275 60.0935 26.2979 58.9488 26.2979C57.5959 26.2979 56.6404 25.8236 56.0822 24.8749C55.5335 23.9262 55.2591 22.3466 55.2591 20.1362V18.6705C55.2875 16.6308 55.5902 15.1461 56.1673 14.2164C56.7444 13.2866 57.6527 12.8218 58.892 12.8218C60.1125 12.8218 61.0207 13.0969 61.6167 13.6472C62.2128 14.1974 62.5297 15.1034 62.5675 16.3651H67.5344C67.3263 14.0409 66.4606 12.2194 64.9375 10.9007C63.4143 9.57253 61.3991 8.90845 58.892 8.90845C57.1512 8.90845 55.6186 9.32587 54.2941 10.1607C52.9696 10.9861 51.9526 12.1625 51.243 13.6898C50.5429 15.2077 50.1929 16.9818 50.1929 19.012V20.0366C50.1929 23.2716 50.9734 25.7761 52.5344 27.5502C54.0954 29.3242 56.2336 30.2113 58.9488 30.2113C60.595 30.2113 62.0567 29.9077 63.3339 29.3005C64.6205 28.6934 65.6186 27.8395 66.3282 26.7391ZM42.5362 22.7119C43.0565 23.1198 43.3167 23.689 43.3167 24.4195C43.3167 25.0646 43.0754 25.5674 42.5929 25.9279C42.1199 26.2789 41.4718 26.4545 40.6488 26.4545C39.3621 26.4545 38.4302 26.1936 37.8531 25.6718C37.2855 25.1405 37.0016 24.3199 37.0016 23.2099H32.0063C32.0063 24.576 32.3469 25.7856 33.0281 26.8387C33.7187 27.8822 34.7405 28.7076 36.0934 29.3148C37.4557 29.9124 38.9742 30.2113 40.6488 30.2113C43.0234 30.2113 44.8919 29.6942 46.2543 28.6602C47.6166 27.6261 48.2978 26.2031 48.2978 24.3911C48.2978 22.1237 47.1814 20.3449 44.9487 19.0547C44.031 18.5234 42.8578 18.0301 41.4293 17.5747C40.0007 17.1099 39.0026 16.664 38.4349 16.2371C37.8673 15.8007 37.5835 15.3168 37.5835 14.7856C37.5835 14.1784 37.8389 13.6804 38.3498 13.2914C38.8701 12.8929 39.575 12.6937 40.4643 12.6937C41.3441 12.6937 42.0395 12.9261 42.5504 13.391C43.0707 13.8559 43.3309 14.5105 43.3309 15.3548H48.2978C48.2978 14.093 47.9714 12.9736 47.3186 11.9964C46.6658 11.0098 45.7481 10.2508 44.5655 9.71958C43.3924 9.18831 42.0631 8.92268 40.5778 8.92268C39.0546 8.92268 37.6828 9.16934 36.4624 9.66265C35.2419 10.1465 34.2959 10.8295 33.6241 11.7118C32.9619 12.5846 32.6308 13.595 32.6308 14.7429C32.6308 17.0482 33.9695 18.8602 36.6469 20.1789C37.4699 20.5868 38.5295 21.009 39.8257 21.4454C41.1218 21.8818 42.0253 22.3039 42.5362 22.7119ZM81.5062 26.056H74.6802L73.4882 29.9267H68.1665L75.7446 9.20728H80.4276L88.0625 29.9267H82.7124L81.5062 26.056ZM75.8723 22.1996H80.3141L78.0861 15.0133L75.8723 22.1996ZM101.807 29.9267H106.76V9.20728H101.793V22.1L94.4845 9.20728H89.5034V29.9267H94.4845V17.034L101.807 29.9267Z" fill="#00043a" />
                                                    </svg>
                                                    <h2>RECUPERAR CLAVE</h2>
                                                </IonCol>
                                            </IonRow>
                                        </IonGrid>
                                    </IonCardTitle>
                                </IonCardHeader>

                                <IonCardContent>
                                    <form onSubmit={handleResetPassword} noValidate>
                                        <IonList>

                                            {/* INPUT NEW PASSWORD */}
                                            <IonItem>
                                                <IonInput
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    onIonChange={handleInputChange}
                                                    value={email}
                                                    required={pageConfig.rules.inputs[inputs.email].required.value}
                                                    minLength={pageConfig.rules.inputs[inputs.email].minLength.value}
                                                    maxLength={pageConfig.rules.inputs[inputs.email].maxLength.value}
                                                    pattern={pageConfig.rules.inputs[inputs.email].pattern.value}
                                                />
                                            </IonItem>

                                            {
                                                validation.summary?.map((v, index) => {

                                                    return v.key === inputs.email &&
                                                        <ValidatorMessageComponent key={index} message={v.message} />
                                                })
                                            }                                            

                                            <IonGrid>
                                                <IonRow>
                                                    <IonButton
                                                        type="submit"
                                                        shape="round"
                                                        size="undefined"
                                                        disabled={!validation.formComplete || !validation.formValid}
                                                    >
                                                        Cambiar clave
                                                    </IonButton>
                                                </IonRow>
                                            </IonGrid>

                                        </IonList>
                                    </form>

                                </IonCardContent>

                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </div>
    )
}
